import { AxiosInstance } from 'axios'
import { Identifier, ListOptions } from './_types'
import { Disease } from './disease'
import { Patient } from './patient'

export type Answer = {
  question: string
  value: string | number
  options?: {
    text: string
    value: string | number
    color?: string
  }[]
  type?: string
}

export enum TaskforceStatus {
  PENDING_ANALYSIS = 'AGUARDANDO_ANALISE',
  PENDING_PHYSICIAN = 'AGUARDANDO_DESIGNACAO',
  CREATED = 'CRIADO',
  PENDING_SCHEDULE = 'AGUARDANDO_AGENDAMENTO',
  SCHEDULED = 'AGENDADO',
  SERVICE_PROVIDED = 'ATENDIDO',
  MISSED = 'FALTOU',
  CANCELED = 'ATENDIMENTO_CANCELADO',
  RESCHEDULED = 'ATENDIMENTO_REAGENDADO',
  DID_NOT_ANSWER = 'NAO_RESPONDEU',
  DID_NOT_SCHEDULE = 'NAO_QUIS_AGENDAR',
  PATIENT_DID_NOT_ANSWER = 'PACIENTE_NAO_RESPONDEU',
  PATIENT_DID_NOT_SCHEDULE = 'PACIENTE_NAO_AGENDOU',
  PENDING_RETURN = 'AGUARDANDO_RETORNO',
  PENDING_ATTENDANCE = 'AGUARDANDO_ATENDIMENTO',
  FINISHED = 'CONCLUIDO',
}

export type TaskforceAnswer = {
  id: number
  status: TaskforceStatus | null
  note: string | null
  answers: Answer[]
  pointsResult?: number
  createdAt: string
  acceptedTerms: boolean
  currentStatusDate: string | null
}

export enum AppointmentType {
  ATTENDANCE = 'CONSULTA',
  RETURN = 'RETORNO',
  CONSULTATION = 'INTERCONSULTA',
}

export type PreviousClinic = {
  id: number
  name: string
  replacedAt: string
}

export type Appointment = {
  id: number | null
  startAt: string
  endAt: string | null
  physician: Identifier
  patient: Identifier | null
  remote: boolean
  type: AppointmentType
  status: 'AGENDADO' | 'CONFIRMADO' | 'AGUARDANDO_ATENDIMENTO' | 'ATENDIDO' | 'REMARCAR' | 'FALTOU' | 'CANCELADO'
}

export type Clinic = Identifier & {
  pharmaceuticalId: number
}

export type Taskforce = {
  id: number
  associatedWithPharmaceuticalId: number | null
  previousClinics: PreviousClinic[] | null
  appointment: Appointment | null
  taskforceAnswer: TaskforceAnswer
  patient: Patient
  disease: Disease
  clinic: Clinic
  inConcierge: boolean
}

export function taskforceEndpoints(apiClient: AxiosInstance) {
  return {
    async list(options: ListOptions<Taskforce> & { search?: string }): Promise<{ items: Taskforce[]; count: number }> {
      return apiClient.get('list-taskforces', {
        params: {
          page: options.pagination?.page,
          itemsPerPage: options.pagination?.itemsPerPage,
          sortBy: options.sort?.at(0)?.by,
          sortDesc: options.sort?.at(0)?.ascending ? !options.sort.at(0)!.ascending : undefined,
          filterBy: options.filters ? JSON.stringify(options.filters) : undefined,
          search: options.search,
        },
      })
    },
  }
}
